import { ContextService } from '../../services/context_service';
import { Datenauswertung } from './Datenauswertung';
import { EnergieCockpit } from './EnergieCockpit2';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { getGewerk } from '../../main/functions/getGewerk';
import { getNoStandortMessage } from './elements/getNoStandortMessage';
import { getStandorte } from '../../helpers/getStandorte';
import { getStandorteGruppenTabRoutings } from '../dateneingabe/functions/StandorteGruppen';
import { getVeranstaltungen } from '../../helpers/getVeranstaltungen';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import { VeranstaltungsAuswahl } from '../../helpers/VeranstaltungsAuswahl';
import { WTabsScrollbar } from '../../core/tabs/WTabsScrollbar';
import { i18n } from '../../i18n/i18n';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';

interface DatenauswertungStandortTabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    reloadData: () => void;
    standortSelected: any;
}

interface DatenauswertungStandortTabsState {
    tabIndex: number;
    tabIndex2: number;
    tabList: any;
    veranstaltungSelected: any;
}

export class DatenauswertungStandortTabs extends React.Component<DatenauswertungStandortTabsProps, DatenauswertungStandortTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: 0,
            tabIndex2: 0,
            tabList: null,
            veranstaltungSelected: null
        };
        this.tabList = React.createRef();
        this.onUpdateScrollbar = this.onUpdateScrollbar.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private hasVeranstaltungen: boolean;
    private modul: string;
    private tabList: any;

    componentDidMount(): void {
        const data: any = this.props.data || {};
        this.hasVeranstaltungen = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig === 1;
        this.modul = data.MODUL_SELECTED || null;
        this.checkRouting();
        this.checkTabIndex();
        this.setState({ tabList: this.tabList.current });
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.modul = (this.props.data || {}).MODUL_SELECTED || null;
            this.checkRouting();
            this.checkTabIndex();
        }
    }

    checkTabIndex() {
        const tabIndex = this.contextService.get('tabIdxDatenauswertungStandort') || 0;
        const tabIndex2 = this.contextService.get(`tabIdxDatenauswertungStandort_${tabIndex}`) || 0;
        if (tabIndex !== this.state.tabIndex) {
            this.setState({ tabIndex });
        }
        if (tabIndex2 !== this.state.tabIndex2) {
            this.setState({ tabIndex2 });
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
        if (routing.path && routing.path[tabName] !== undefined) {
            if (routing.path.terminateOn === tabName) {
                const veranstaltungSelected: any = routing.standort ? (getVeranstaltungen(this.props.data) || []).find((item: any) => item.tid === routing.standort) : null;
                if (veranstaltungSelected && veranstaltungSelected !== this.state.veranstaltungSelected) {
                    this.setState({ veranstaltungSelected });
                }
            }
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        /*
        } else if (Object.keys(routing.path || {}).length && !this.state.tabIndex) {
            const indexStandorte: number = ((getStandorte(this.props.data || {}) || []).length > 1 || this.hasVeranstaltungen) ? 1 : 2;
            if (this.modul === 'cfm') {
                const path: any = {
                    ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS,
                    [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: indexStandorte,
                    [RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS]: 0,
                    terminateOn: RoutingIDs.TABS_DATENAUSWERTUNG_CO2_FUSS
                }
                setTimeout(() => this.props.onRoutingChange({ path }));
            } else if (this.modul === 'steuer') {
                const path: any = { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIESTEUER, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: 1 };
                setTimeout(() => this.props.onRoutingChange({ path }));
            }
        */
        }

        const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
        if (routing.path && routing.path[tabName2] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName2) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex2(routing.path[tabName2], routing);
            if (this.state.tabIndex2 === routing.path[tabName2]) {
                if (routing.path.terminateOn === tabName2) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex2(routing.path[tabName2], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDatenauswertungStandort', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    setTabIndex2(tabIndex2: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex2 !== tabIndex2) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
            if (routing.path && routing.path[tabName2] === undefined) {
                // init default tabIndex2
                routing.path[tabName2] = this.state.tabIndex2;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex2 }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(`tabIdxDatenauswertungStandort_${this.state.tabIndex}`, tabIndex2);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    onUpdateScrollbar(): void {
        this.setState({ tabList: this.tabList.current });
    }

    render(): JSX.Element {
        const data: any = this.props.data || {};
        const standorte: any[] = getStandorte(data) || [];
        if (standorte.length === 0) {
            return getNoStandortMessage();
        }

        const basisRouting = { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STANDORTE };
        const basisTab = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
        const tabRoutings = [
            {
                name: 'Energie-Cockpit',
                disabled: this.modul === 'cfm' || this.modul === 'steuer',
                path: {
                    ...basisRouting,
                    [basisTab]: 0,
                    terminateOn: basisTab
                }
            },
            {
                name: 'Gesamtunternehmen',
                path: {
                    ...basisRouting,
                    [basisTab]: 1,
                    terminateOn: basisTab
                }
            },
            ...getStandorteGruppenTabRoutings(this.props.data, basisRouting, basisTab, 2)
        ];
        const showGesamt: boolean = standorte.length > 1 || this.hasVeranstaltungen;

        if (this.hasVeranstaltungen) {
            // Tab Veranstaltungen
            tabRoutings.push({
                name: 'Veranstaltungen',
                path: {
                    ...basisRouting,
                    [basisTab]: tabRoutings.length,
                    terminateOn: basisTab
                }
            });
        }

        return <>
            {this.state.tabList &&
                <WTabsScrollbar
                    tabList={this.state.tabList}
                />
            }
            <Tabs
                className='tabs-datenauswertung'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflowY: 'auto' }}
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList
                    style={{ display: 'none', whiteSpace: 'nowrap', overflow: 'auto hidden' }}
                    onScroll={this.onUpdateScrollbar}
                    ref={this.tabList}
                >
                    {tabRoutings.map((r: any, idx: number) =>
                        <Tab
                            key={`tab-${idx}`}
                            disabled={!!(
                                (r.name === 'Gesamtunternehmen' && !showGesamt) || (r.name === 'Veranstaltungen' && !this.hasVeranstaltungen)
                                || r.disabled
                            )}
                        >
                            {['Energie-Cockpit', 'Gesamtunternehmen', 'Veranstaltungen'].indexOf(r.name) >= 0 ? i18n(r.name, 'tab') : r.name}
                        </Tab>
                    )}
                </TabList>
                {tabRoutings.map((r: any, idx: number) => {
                    switch (r.name) {
                        case 'Energie-Cockpit':
                            return this.renderTabPanelEnergieCockpit(r);
                        case 'Gesamtunternehmen':
                            return this.renderTabPanelGesamt();
                        case 'Veranstaltungen':
                            return this.renderTabPanelVeranstaltung(r);
                        default:
                            return this.renderTabPanel(idx, r);
                    }
                })}
            </Tabs>
        </>;
    }

    renderTabPanel(idx: number, routing: any): JSX.Element {
        if (Array.isArray(routing.children)) {
            return this.renderTabPanelGruppe(idx, routing);
        } else {
            return this.renderTabPanelSingle(idx, undefined, routing);
        }
    }

    renderTabPanelGruppe(idx: number, routing: any): JSX.Element {
        const tabRoutings = routing && routing.path && Array.isArray(routing.children) ? routing.children : [];
        return <TabPanel
            key={`panel-${idx}`}
            style={{
                flexDirection: 'column', display: 'flex', minHeight: 0,
                flex: this.state.tabIndex === idx ? 1 : 0
            }}
        >
            <Tabs
                className='tabs-datenauswertung'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflowY: 'auto' }}
                selectedIndex={this.state.tabIndex2}
                onSelect={(tabIndex2, lastIndex, event) => this.setTabIndex2(tabIndex2, tabRoutings[tabIndex2])}
            >
                <TabList>
                    {tabRoutings.map((r: any, idx2: number) => <Tab key={`tab-${idx}-${idx2}`}>{r.name}</Tab>)}
                </TabList>
                {tabRoutings.map((r: any, idx2: number) => this.renderTabPanelSingle(idx, idx2, r))}
            </Tabs >
        </TabPanel>;
    }

    renderTabPanelSingle(idx: number, idx2: number, routing: any): JSX.Element {
        const data: any = this.props.data || {};
        const standorte: any[] = getStandorte(data) || [];
        const dataRow = routing.dataRow || {};
        const routingMerged = JSON.parse(JSON.stringify({
            ...routing,
            ...this.props.routing
        }));
        // Eigene Tabs übernehmen
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
        const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
        if (routingMerged.path) {
            routingMerged.path[tabName] = this.state.tabIndex;
            routingMerged.path[tabName2] = this.state.tabIndex2;
        }
        return <TabPanel
            key={idx2 >= 0 ? `panel-${idx}-${idx2}` : `panel-${idx}`}
            style={{
                flexDirection: 'column', display: 'flex', minHeight: 0,
                flex: this.state.tabIndex === idx && (idx2 >= 0 ? this.state.tabIndex2 === idx2 : true) ? 1 : 0
            }}
        >
            <Datenauswertung
                data={this.props.data}
                onRoutingChange={this.props.onRoutingChange}
                reloadData={this.props.reloadData}
                routing={routingMerged}
                standortTid={dataRow.tid}
                standortName={standorte.length === 1 ? '' : `${i18n('Standort', 'sys')}: ${dataRow.name || ''}`}
            />
        </TabPanel>;
    }

    renderTabPanelEnergieCockpit(routing: any): JSX.Element {
        const data: any = this.props.data || {};
        const gewerk = getGewerk(data);
        const hasGewerke: boolean = gewerk !== undefined && gewerk > 0;

        if (!Object.keys(this.props.routing || {}).length && this.state.tabIndex === 0) {
            const indexStandorte: number = ((getStandorte(data) || []).length > 1 || this.hasVeranstaltungen) ? 1 : 2;
            if (this.modul === 'cfm') {
                const path: any = { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: indexStandorte };
                setTimeout(() => this.props.onRoutingChange({ path }), 500);
            } else if (this.modul === 'steuer') {
                const path: any = { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIESTEUER, [RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE]: 1 };
                setTimeout(() => this.props.onRoutingChange({ path }), 500);
            }
        }

        return (
            <TabPanel
                style={{
                    flexDirection: 'column', display: 'flex', minHeight: 0/*, overflowY: 'auto'*/, flex: this.state.tabIndex === 0 ? 1 : 0
                }}
            >
                {!routing.disabled && <>
                    {hasGewerke && getDefaultHelpIcon('pageEnergieCockpit', i18n('Hilfe zum EnergieCockpit', 'sys'), this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                    <EnergieCockpit
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        routing={this.props.routing}
                    />
                </>}
            </TabPanel>
        );
    }

    renderTabPanelGesamt(): JSX.Element {
        return (
            <TabPanel>
                <Datenauswertung
                    data={this.props.data}
                    onRoutingChange={this.props.onRoutingChange}
                    reloadData={this.props.reloadData}
                    routing={this.props.routing}
                    standortTid={undefined}
                    standortName={i18n('Alle Standorte', 'sys')}
                />
            </TabPanel>
        );
    }

    renderTabPanelVeranstaltung(routing: any): JSX.Element {
        const data: any = this.props.data || {};
        const standorte: any[] = getStandorte(data) || [];
        const routingMerged = JSON.parse(JSON.stringify({
            ...routing,
            ...this.props.routing
        }));
        // Eigene Tabs übernehmen
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE;
        const tabName2: string = RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM;
        if (routingMerged.path) {
            routingMerged.path[tabName] = this.state.tabIndex;
            routingMerged.path[tabName2] = this.state.tabIndex2;
        }
        return (
            <TabPanel>
                <VeranstaltungsAuswahl
                    data={this.props.data}
                    veranstaltung={this.state.veranstaltungSelected}
                    onVeranstaltungSelect={(veranstaltung: any) => this.setState({ veranstaltungSelected: veranstaltung })}
                />
                {this.state.veranstaltungSelected ?
                    <Datenauswertung
                        key={`Datenauswertung_${this.state.veranstaltungSelected.tid}`}
                        data={this.props.data}
                        onRoutingChange={this.props.onRoutingChange}
                        reloadData={this.props.reloadData}
                        routing={routingMerged}
                        standortTid={this.state.veranstaltungSelected.tid}
                        standortName={standorte.length === 1 ? '' : `${i18n('Veranstaltung', 'sys')}: ${this.state.veranstaltungSelected.name || ''}`}
                    /> :
                    <div>Bitte eine Veranstaltung wählen!</div>
                }
            </TabPanel>
        );
    }
}
